import { Project } from '@/app/models/project';
import TruncatedTextWithTooltip from '@/app/utils/truncatedTextWithTooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import DataTable, { bodyCellSmallSx, bodyCellSx, Column } from '../common/DataTable';

interface SpecificAllocation {
  project: Project;
}

interface NewEditAllocationConstraintTableProps {
  itens: SpecificAllocation[];
  onRemove: (id: number) => void;
}

export default function NewEditAllocationConstraintTable({ itens, onRemove }: NewEditAllocationConstraintTableProps) {
  const { t } = useTranslation(['specificAllocation', 'common']);

  const handleDelete = (id: number) => {
    if (id) {
      onRemove(id);
    }
  };

  const columns: Column[] = [
    { key: 'project', label: t('common:project') },
    {
      key: 'actions',
      label: t('common:actions'),
      align: 'right',
    },
  ];

  const renderRow = (item: SpecificAllocation) => {
    return (
      <>
        <TableCell sx={bodyCellSx}>
          <TruncatedTextWithTooltip sx={bodyCellSx} value={`${item.project.code} - ${item.project.name}`} size={80} />
        </TableCell>

        <TableCell align="right" sx={bodyCellSmallSx}>
          <IconButton size="small" onClick={() => handleDelete(item.project.id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </>
    );
  };

  return (
    <DataTable
      columns={columns}
      data={itens}
      renderRow={renderRow}
      getRowKey={(item) => item.project.id}
      emptyMessage={t('common:no.results.found')}
      size="small"
      stickyHeader
      maxHeight="25rem"
    />
  );
}
